import React from 'react';

const Login = React.lazy(() => import('./pages/Login'));
const ManuelAdjustment = React.lazy(() => import('./containers/ManuelAdjustment/ManuelAdjustment'));

const SelectProject = React.lazy(() => import('./pages/SelectProject'));

const Dashboard = React.lazy(() => import('./pages/Dashboard'));

const Users = React.lazy(() => import('./containers/Users'));
const EditUser = React.lazy(() => import('./containers/Users/EditUser/EditUser'));
const AddUser = React.lazy(() => import('./containers/Users/AddUser/AddUser'));

const Projects = React.lazy(() => import('./containers/Projects'));



const Roles = React.lazy(() => import('./containers/Roles'));
const AddRole = React.lazy(() => import('./containers/Roles/AddRole/AddRole'));
const RolePages = React.lazy(() => import('./containers/RolePages'));

const Transactions = React.lazy(() => import('./containers/Transactions/Transactions'));
const TransactionDetails = React.lazy(() => import('./containers/Transactions/TransactionPages/TransactionRefundReverse'));

const InvoiceInfo = React.lazy(() => import('./containers/InvoiceInfo/InvoiceInfo'));
const FinancialStatementReport = React.lazy(() => import('./containers/FinancialStatementReport/FinancialStatementReport'));


const Reports2 = React.lazy(() => import('./containers/Reports2/Reports'));

const PaymentHistory = React.lazy(() => import('./containers/PaymentHistory/PaymentHistory'));
const PaymentDetails= React.lazy(() => import('./containers/PaymentHistory/PaymentDetail/PaymentDetail'));
const PaymentRefund= React.lazy(() => import('./containers/PaymentHistory/Refund/Refund'));

const SummaryReport = React.lazy(() => import('./containers/SummaryReport/SummaryReport'));
const SummaryReportForAdmin = React.lazy(() => import('./containers/SummaryReportForAdmin/SummaryReportForAdmin'));
const AccountActivities = React.lazy(() => import('./containers/AccountActivities/AccountActivities'));
const AccountActivitiesForAdmin = React.lazy(() => import('./containers/AccountActivitiesForAdmin/AccountActivitiesForAdmin'));

const MerchantBankIds = React.lazy(() => import('./containers/MerchantBankIds/MerchantBankIds'));
const TransactionReport = React.lazy(() => import('./containers/TransactionReport/TransactionReport'));


const BankCards = React.lazy(() => import('./containers/BankCards/BankCards'));
const CardDetail = React.lazy(() => import('./containers/BankCards/BankCardsDetail/BankCardsDetail'));

//Onboarding
const RegistrationOfCustomer = React.lazy(() => import('./containers/Onboarding/Registration'));
const TerminatedMerchants = React.lazy(() => import('./containers/Onboarding/TerminatedMerchants'));
const DistributorMembers = React.lazy(() => import('./containers/Onboarding/DistributorMembers/DistributorMembers'));
const PlatePointDefinitions = React.lazy(() => import('./containers/Onboarding/PlatePointDefinitions/PlatePointDefinitions'));

const CustomerDetail = React.lazy(() => import('./containers/Onboarding/CustomerDetail/CustomerDetail'));

const CreateCustomer = React.lazy(() => import('./containers/Onboarding/CreateCustomer/CreateCustomer'));

//User List



//WidgetsPage
const WidgetsPage = React.lazy(() => import('./containers/WidgetPage/WidgetsPage'));


const Widget = React.lazy(() => import('./containers/MerchantWidget/MerchantWidget'));




//MailSms
const SendMail = React.lazy(() => import('./containers/MailSms/SendMail/SendMail'));
const SendSms = React.lazy(() => import('./containers/MailSms/SendSms/SendSms'));
const HistoryMailSms = React.lazy(() => import('./containers/MailSms/History/HistoryMailSms'));

//Commission

const Commission = React.lazy(() => import('./containers/Commission/Commission'));
const CommissionDescription = React.lazy(() => import('./containers/Commission/Description/CommissionDescription'));

//Account Balance
const AccountBalance = React.lazy(() => import('./containers/AccountBalance/AccountBalance'));
const BalanceTransfer = React.lazy(() => import('./containers/AccountBalance/BalanceTransfer/BalanceTransfer'));

//Merchant Account Balance

const MerchantAccountBalance = React.lazy(() => import('./containers/MerchantAccountBalance/MerchantAccountBalance'));

// End Users Bank Cards

const PayzeeMerchantAndEndUsers = React.lazy(() => import('./containers/PayzeeEndUsers/MerchantList'));
const EndUserList = React.lazy(() => import('./containers/PayzeeEndUsers/EndUserList'));
const MerchantEndUsers = React.lazy(() => import('./containers/MerchantEndUsers/MerchantEndUserList'));


// Banks
const Banks = React.lazy(() => import('./containers/Banks/Banks'));
const BankCommission = React.lazy(() => import('./containers/Banks/BankDetails/BankCommissionDetail'));

//Approvements
const Approvements = React.lazy(() => import('./containers/Approvements/PayzeeApprovementsPage'));

//Bank's Merchants
const BanksMerchants = React.lazy(() => import('./containers/BanksMerchants/BanksMerchants'));

//Bank's Transactions
const BanksTransactions = React.lazy(() => import('./containers/BanksTransactions/BanksTransaction'));


//MCC And Certificate
const Mcc = React.lazy(() => import('./containers/MccCertificate/MccCertificate'));

//Banks and Bin List 
const BankList = React.lazy(() => import('./containers/BinList/BankList'));
const BinList = React.lazy(() => import('./containers/BinList/BankBins/BankBins'));
const BankListPlaceholder = React.lazy(() => import('./containers/BankListPlaceholder/BankListPlaceholder'));

// Kiosk Definitions
const KioskDefinitions = React.lazy(() => import('./containers/KioskDefinitions/KioskDefinitions'));
const KioskDefinitionDetail = React.lazy(() => import('./containers/KioskDefinitions/KioskDefinitionDetails/KioskDefinitionDetails'));

//Transfer Limits
const TransferLimits = React.lazy(() => import('./containers/TransferLimits/TransferLimits'));


const CreatePayLink = React.lazy(() => import('./containers/CreatePayLink/CreatePayLink'));
const MerchantPayLinkCreate = React.lazy(() => import('./containers/CreatePayLink/CreatePayLinkMerchant'));


const CreateConstantPayment = React.lazy(() => import('./containers/ConstantLinks/ConstantLinks'));

const MerchantReports = React.lazy(() => import('./containers/MerchantReports/MerchantReports'));

const MonthlyReportForMerchant = React.lazy(() => import('./containers/MonthlyReportForMerchant/index'));
const PayByCreditCard = React.lazy(() => import('./containers/PayByCreditCard/index'));
const CustomerManagement = React.lazy(() => import('./containers/CustomerManagement'));
const PosInventoryManagement = React.lazy(() => import('./containers/PosInventoryManagement'));
const PosDeviceTracking = React.lazy(() => import('./containers/PosDeviceTracking'));
const AuthorizedTransactions = React.lazy(() => import('./containers/AuthorizedTransactions'));
const CashManagement = React.lazy(() => import('./containers/CashManagement'));
const TransactionRequestView = React.lazy(() => import('./containers/TransactionRequestView'));
const RequestList = React.lazy(() => import('./containers/RequestList/RequestList'));

const TcmbRibsIslemler = React.lazy(() => import('./containers/TcmbRibs').then(m => ({ default: m.TcmbRibsIslemlerPage })));
const TcmbRibsIsyerleri = React.lazy(() => import('./containers/TcmbRibs').then(m => ({ default: m.TcmbRibsIsyerleriPage })));
const TcmbRibsDonemler = React.lazy(() => import('./containers/TcmbRibs').then(m => ({ default: m.TcmbRibsDonemlerPage })));
const TcmbRibsLoglar = React.lazy(() => import('./containers/TcmbRibs').then(m => ({ default: m.TcmbRibsLoglarPage })));
const TcmbRibsKayitDetail = React.lazy(() => import('./containers/TcmbRibs').then(m => ({ default: m.TcmbRibsKayitDetailPage })));

const WorkingHoursProfiles = React.lazy(() => import('./containers/WorkingHours/ProfileListPage'));
const WorkingHoursProfileForm = React.lazy(() => import('./containers/WorkingHours/ProfileFormPage'));
const LoginLogs = React.lazy(() => import('./containers/WorkingHours/LoginLogsPage'));

const DmsCategories = React.lazy(() => import('./containers/Dms/CategoriesPage'));
const DmsSystemDocuments = React.lazy(() => import('./containers/Dms/SystemDocumentsPage'));
const DmsProjectTracking = React.lazy(() => import('./containers/Dms/ProjectTrackingPage'));
const DmsMyDocuments = React.lazy(() => import('./containers/Dms/MyDocumentsPage'));
const DmsNotifyRedirect = React.lazy(() => import('./containers/Dms/NotifyPermissionRedirect'));

const BtransSfpQueue = React.lazy(() => import('./containers/BtransSfp/QueuePage'));
const BtransSfpReports = React.lazy(() => import('./containers/BtransSfp/ReportsPage'));
const BtransSfpReportDetail = React.lazy(() => import('./containers/BtransSfp/ReportDetailPage'));
const BtransSfpItems = React.lazy(() => import('./containers/BtransSfp/ItemsPage'));


// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  // {path: '/', exact: true, name: 'Homeless', component: DefaultLayout},
  {path: '/home', name: 'dashboard1', component: Dashboard},

  {path: '/projects', exact: true, name: 'projects1', component: Projects},



  {path: '/login', name: 'login', component: Login},

  {path: '/users',exact:true, name: 'users1', component: Users},
  {path: '/users/new/:projectId',exact:true, name: 'add_users_page', component: AddUser},
  {path: '/users/edit/:id',exact:true, name: 'edit_users_page', component: EditUser},

  {path: '/SelectProject', name: 'projects1', component: SelectProject},
 


  {path: '/roles', exact: true, name: 'roles1', component: Roles},
  {path: '/rolePages', exact: true, name: 'role_pages1', component: RolePages},
  {path: '/roles/new', exact: true, name: 'add_role', component: AddRole},

 
  /*Admin Page Routes */

  //Transactions
  {path: '/transactions/', exact:true, name: 'transactions.transactions', component: Transactions},
  {path: '/transactions/:transactionDetail', exact:true, name: 'transactionDetail', component: TransactionDetails},
  

  {path: '/fatura-bilgileri/', exact:true, name: 'fatura-bilgileri', component: InvoiceInfo},
  {path: '/maliye-bildirim-formu/', exact:true, name: 'maliye-bildirim-formu', component: FinancialStatementReport},

  
  //Reports
  {path: '/reportaz/', exact:true, name: 'reportaz', component: Reports2},




  /*Personal Cabinet (Merchant) Page Routes */
  //Payment History Pages
  {path: '/payment-history/', exact:true, name: 'payment-history', component: PaymentHistory},
  {path: '/payment-history/:paymentId', exact:true, name: 'payment-details', component: PaymentDetails},
  {path: '/payment-history/refund-reverse/:transactionDetail', exact:true, name: 'payment-refund', component: PaymentRefund},
  {path: '/summary-report/', exact:true, name: 'summary-report', component: SummaryReport},
  {path: '/summary-report-for-admin/', exact:true, name: 'summary-report-for-admin', component: SummaryReportForAdmin},

  {path: '/account-activites/', exact:true, name: 'account-activites', component: AccountActivities},
  
  {path: '/account-activites-for-admin/', exact:true, name: 'account-activites-for-admin', component: AccountActivitiesForAdmin},
  {path: '/merchant-bank-ids/', exact:true, name: 'merchantBankIds', component: MerchantBankIds},
  {path: '/transaction-report/', exact:true, name: 'transactionReport', component: TransactionReport},

  
  //List Of Bank Cards
  {path: '/bank-cards/', exact:true, name: 'bank-cards', component: BankCards},
  {path: '/bank-cards/new', exact:true, name: 'card-detail', component: CardDetail},




 /*Onboarding Pages Routes */

 {path: '/registration-of-customer/', exact:true, name: 'registration-of-customer', component: RegistrationOfCustomer},

 {path: '/registration-of-customer/create-customer', exact:true, name: 'create-customer', component: CreateCustomer},
 
 {path: '/registration-of-customer/:id', exact:true, name: 'customer-details', component: CustomerDetail},

 {path: '/feshedilen-firmalar', exact:true, name: 'feshedilen-firmalar', component: TerminatedMerchants},

 {path: '/distributor-members', exact:true, name: 'altimdakiler', component: DistributorMembers},

 {path: '/plaka-nokta', exact:true, name: 'plaka-nokta', component: PlatePointDefinitions},

 //Widget Form Page
 {path: '/merchant-widgets', exact:true, name: 'widgets-page', component: WidgetsPage},

 {path: '/widget', exact:true, name: 'widgets-page', component: Widget},



 //MailSms
 {path: '/send-mail/', exact:true, name: 'send-mail', component: SendMail},
 {path: '/send-sms/', exact:true, name: 'send-sms', component: SendSms},
 {path: '/mail-sms-history/', exact:true, name: 'mail-sms-history', component: HistoryMailSms},

 //Commission
 {path: '/commission/', exact:true, name: 'commission', component: Commission},
 {path: '/commission/:Id/', exact:true, name: 'commission-description', component: CommissionDescription},

 //Account Balance
 {path: '/account-balance/', exact:true, name: 'account-balance', component: AccountBalance},
 {path: '/account-balance/:Id', exact:true, name: 'balance-transfer', component: BalanceTransfer},

 //Merchant Account Balance
 {path: '/merchant-account-balance/', exact:true, name: 'merchant-account-balance', component: MerchantAccountBalance},

 // End Users Bank Cards

 {path: '/payzee-end-users/', exact:true, name: 'payzee-end-users', component: PayzeeMerchantAndEndUsers},
 {path: '/payzee-end-users/:merchantId', exact:true, name: 'merchant-end-users', component: EndUserList},
 
 {path: '/merchant-end-users', exact:true, name: 'merchant-end-users', component: MerchantEndUsers},

 //Banks

 {path: '/bank-detail/', exact:true, name: 'bank-detail', component: Banks},
 {path: '/bank-detail/:Id', exact:true, name: 'bank-detail', component: BankCommission},
 //Approvement

 {path: '/approvement-list/', exact:true, name: 'approvement-list', component: Approvements},
 {path: '/banks-merchant-list/', exact:true, name: 'banks-merchant-list', component: BanksMerchants},
 {path: '/banks-transaction-list/', exact:true, name: 'banks-transaction-list', component: BanksTransactions},


 //Mcc Certificate
 {path: '/mcc-certificate/', exact:true, name: 'mcc-certificate', component: Mcc},
 
 //Mcc Certificate
 {path: '/bin-list/', exact:true, name: 'bin-list', component: BankList},
{path: '/bank-list/', exact:true, name: 'bank-list', component: BankListPlaceholder},
 {path: '/bin-list/:binId', exact:true, name: 'bin-detail', component: BinList},

 // Kiosk Definitions
 {path: '/kiosk-definitions/', exact:true, name: 'kiosk-definitions', component: KioskDefinitions},
 {path: '/kiosk-definitions/:kioskId', exact:true, name: 'kiosk-definitions', component: KioskDefinitionDetail},



 {path: '/pay-link-create/', exact:true, name: 'Create Pay Link', component: CreatePayLink},
 {path: '/merchant-pay-link-create/', exact:true, name: 'Create Pay Link', component: MerchantPayLinkCreate},

 {path: '/constant-links/', exact:true, name: 'Create Pay Link', component: CreateConstantPayment},


 {path: '/transfer-authorize-and-limits/', exact:true, name: 'Transfer Limits', component: TransferLimits},


 {path: '/merchant-reports/', exact:true, name: 'Merchant Report', component: MerchantReports},

 {path: '/manuel-adjustments/', exact:true, name: 'Manuel Adjustment', component: ManuelAdjustment},

 {path: '/monthly-report-for-merchant/', exact:true, name: 'Ay Sonu Dekontu', component: MonthlyReportForMerchant},
 
 {path: '/pay-by-credit-card/', exact:true, name: 'Kredi Kartı İle Ödeme', component: PayByCreditCard},

  {path: '/customer-management/', exact:true, name: 'customerManagement', component: CustomerManagement},
  {path: '/pos-inventory-management', exact:true, name: 'posInventoryManagement', component: PosInventoryManagement},
  {path: '/pos-device-tracking', exact:true, name: 'posDeviceTracking', component: PosDeviceTracking},
  {path: '/authorized-transactions/', exact:true, name: 'authorizedTransactions', component: AuthorizedTransactions},
  {path: '/cash-management/', exact:true, name: 'cashManagement', component: CashManagement},
  {path: '/transaction-request-view', exact:true, name: 'transactionRequestView', component: TransactionRequestView},
  {path: '/request-list', exact:true, name: 'requestList', component: RequestList},

  {path: '/tcmb-ribs/islemler', exact:true, name: 'tcmbRibsIslemler', component: TcmbRibsIslemler},
  {path: '/tcmb-ribs/isyerleri', exact:true, name: 'tcmbRibsIsyerleri', component: TcmbRibsIsyerleri},
  {path: '/tcmb-ribs/donemler', exact:true, name: 'tcmbRibsDonemler', component: TcmbRibsDonemler},
  {path: '/tcmb-ribs/loglar', exact:true, name: 'tcmbRibsLoglar', component: TcmbRibsLoglar},
  {path: '/tcmb-ribs/kayitlar/:id', exact:true, name: 'tcmbRibsKayitDetail', component: TcmbRibsKayitDetail},

  {path: '/calisma-saatleri', exact:true, name: 'calismaSaatleriProfiller', component: WorkingHoursProfiles},
  {path: '/calisma-saatleri/yeni', exact:true, name: 'calismaSaatleriProfilYeni', component: WorkingHoursProfileForm},
  {path: '/calisma-saatleri/:id', exact:true, name: 'calismaSaatleriProfilDuzenle', component: WorkingHoursProfileForm},
  {path: '/giris-loglari', exact:true, name: 'girisLoglari', component: LoginLogs},
  {path: '/documents/categories', exact:true, name: 'dmsCategories', component: DmsCategories},
  {path: '/documents/system', exact:true, name: 'dmsSystemDocuments', component: DmsSystemDocuments},
  {path: '/documents/project-tracking', exact:true, name: 'dmsProjectTracking', component: DmsProjectTracking},
  {path: '/my-documents', exact:true, name: 'dmsMyDocuments', component: DmsMyDocuments},
  // Menüde gösterilmez; eski/yanlış link home yerine takibe düşer
  {path: '/documents-project-notify', exact:true, name: 'dmsProjectTracking', component: DmsNotifyRedirect},

  {path: '/btrans-sfp/ozet', exact:true, name: 'btransSfpOzet', component: BtransSfpQueue},
  {path: '/btrans-sfp/dosyalar', exact:true, name: 'btransSfpDosyalar', component: BtransSfpReports},
  {path: '/btrans-sfp/dosyalar/:id', exact:true, name: 'btransSfpDosyaDetay', component: BtransSfpReportDetail},
  {path: '/btrans-sfp/satirlar', exact:true, name: 'btransSfpSatirlar', component: BtransSfpItems},
];

export default routes;
